import pinpoint from './pinpoint';
import pinpoint1 from './pinpoint1';
import pinpoint2 from './pinpoint2';
import pinpoint3 from './pinpoint3';
import pinpoint4 from './pinpoint4';
import pinpoint5 from './pinpoint5';
import pinpoint6 from './pinpoint6';

import copy from './copy';

import { hit, miss, validation, target, actuarial } from './tags';

export { default as pinpoint } from './pinpoint';
export { default as pinpoint1 } from './pinpoint1';
export { default as pinpoint2 } from './pinpoint2';
export { default as pinpoint3 } from './pinpoint3';
export { default as pinpoint4 } from './pinpoint4';
export { default as pinpoint5 } from './pinpoint5';
export { default as pinpoint6 } from './pinpoint6';

export { default as copy } from './copy';

const themes = {
  light: pinpoint,
  pinpoint,
  pinpoint1,
  pinpoint2,
  pinpoint3,
  pinpoint4,
  pinpoint5,
  pinpoint6,
  copy,
  hit,
  cluster: hit,
  miss,
  validation,
  target,
  actuarial,
  'hi freq': actuarial,
  'lo freq': actuarial,
};

export default themes;
